let labels = {
	'':'',
	null:'',
	undefiend:'',
	'独资':'Sole proprietorship',
	'合资/合股':'Joint venture/joint stock',
	'承包':'Contract',
	'租赁':'Lease',
	'其他':'Other',
	'下属企业':'Subsidiary company',
	'竞争关系':'Competitive relationship',
	'无':'None',
	'配偶':'Spouse',
	'子女':'Children',
	'本人及配偶的父母':'I and my spouse\'s parents',
	'供应商':'Supplier',
	'客户':'Client',
	'代理商':'Agent',
	'竞争方':'Competitors',
	'往来个人':'To and from individuals',
	'往来公司':'Contact company',
	'内部':'Internal',
	'亲属':'Relatives',
	'同学':'Colleague',
	'朋友':'Friend',
	'投资信息':'Investment Information',
	'企业信息':'Company information',
	'本人':'I',
	'他人名义':'In the name of others',
	'姓名':'Name',
	'手机号':'Mobile phone number',
	'投资模式':'Investment model',
	'占比':'Percent',
	'其他':'Other',
	'描述':'Description',
	'备注':'Remarks',
	'请填写申报事项描述':'Please fill in the declaration description',
	'添加成功':'Added successfully',
	'删除成功':'Deleted successfully',
	'关系人信息':'Related Person Information',
	'关系':'Relationship',
	'与三一集团的关系':'Relationship with SANY Group',
	'投资类型':'Types of investment',
	'独资':'Sole proprietorship',
	'合资/合股':'Joint venture/joint stock',
	'暂存':'Temporary storage',
	'是':'Yes',
	'否':'No',
	'任职岗位':'Job position',
	'企业关系':'Corporate Relations',
	'人员信息':'Personnel information',
	'个人姓名':'Personal name',
	'联系电话':'Contact number',
	'任职单位类型':'Type of work unit',
	'职工信息':'Employee information',
	'业务类型':'Business type',
	'业务描述':'Business Description',
	'事项描述':'Description of the matter',
	'关系人':'Related Person',
	'请填写...':'Please fill in your ',
	'请选择...':'Please select a ',
	'选择员工':'Select an employee',
	'暂无数据，请重新输入查询条件':'No data yet, please re-enter the query conditions',
	'模糊搜索':'Fuzzy search',
	'员工':'Staff',
	'请选择员工':'Please select an employee',
	'廉洁承诺书':'Integrity Commitment',
	'个企业':'company',
	'下一步':'Next step',
	'请问需要添加的关系人是当前企业的吗？':'Is the relationship person that needs to be added to the current enterprise?',
	'请选择是否有申报关联！':'Please select whether there is a declaration connection!',
	'往来类型':'Type of communication',
	'关闭':'Close',
	'请确认是否暂存':'Please confirm whether it is temporarily stored.',
	'请确认是否提交数据，提交后数据将不能修改。':'Please confirm whether to submit the data, the data cannot be modified after submission.',
	'已申报':'Declared',
	'暂存成功，是否关闭页面？':'The temporary storage was successful, do you want to close the page?',
	'申报提交成功，是否关闭页面？':'The application was submitted successfully, do you want to close the page?',
	'操作失败，请联系管理员 田辉阳 (tianhy16)':'Operation failed, please contact the administrator 田辉阳 (tianhy16)',
	'已取消填充，如需填充请刷新页面':'Filling has been cancelled, please refresh the page if you want to fill it',
	'已填充成功，如需取消请刷新页面':'It has been filled successfully, if you want to cancel, please refresh the page',
	'提醒':'Remind',
	'警告':'Warning',
	'填充':'Fill',
	'不填充':'Do not fill',
	'利益冲突申报':'Conflict of interest',
	'企业名称':'Company name',


	'本人父母':'My parents',
	'配偶父母':'Spouse\'s parents',
	'子女':'Children',
	'子女配偶及其父母':'Children\'s spouse and their parents',
	'祖（外）父母':'Grandparents',
	'（外）孙子女':'Grandchildren',
	'（外）孙子女配偶及其父母':'Grandchildren\'s spouse and their parents',
	'继父母':'Stepparents',
	'继子女':'Stepchildren',
	'继子女配偶及其父母':'Stepchildren\'s spouse and their parents',
	'亲兄弟姐妹（及其配偶）':'Brothers and sisters (and their spouses)',
	'伯叔（母）':'Uncle (mother)',
	'姑母（父）':'Aunt (father)',
	'堂兄弟姐妹（及其配偶）':'Cousins (and their spouses)',
	'舅父（母）':'Uncle (mother)',
	'姨母（父）':'Aunt (father)',
	'表兄弟姐妹（及其配偶）':'Cousins (and their spouses)',
	'侄子女（及其配偶）':'Nephews (and their spouses)',
	'甥子女（及其配偶）':'Nephews (and their spouses)',
	'其他亲友':'Other relatives and friends',

	'亲友':'Family and friends',
	'老乡':'Fellow',
	'基建施工':'Infrastructure Construction',
	'采购':'Procurement',
	'外协':'Outsourcing',
	'零部件加工':'Parts Processing',
	'供应商相关':'Supplier Related',
	'来源附件':'Source Annex',
	'附件':'Annex',
	'个关系人':' related person',
	'个职工':' employee',
	'申报描述：':'Declaration description:',
	'本人承诺已就相关利益冲突事项进行了以上如实申报，愿意接受公司的监督，如有不实之处，愿意接受公司的制度处理。':'I promise that I have made the above truthful declaration on relevant conflict of interest matters, and I am willing to accept the supervision of the company. If there is any inaccuracy, I am willing to accept the system of the company.',
	'若申报后相关情况发生重大变化，应在30个工作日内补充申报':'If there is a significant change in the relevant situation after the declaration, the supplementary declaration shall be made within 30 working days',
	'上一步':'Previous step',
	'提交':'Submit',
	'请填写企业名称后再搜索':'Please fill in the company name before searching',
	'搜索出来的企业是您输入的企业？':'Is the company you entered the business?',
	'不是':'No',
	'请您输入企业全称搜索!!!':'Please enter the full name of the enterprise to search!!!',
	'企业搜索成功':'Business Search Success',
	'未找到公司，请输入企业全名。':'Company not found, please enter full name.',
	'请问需要添加的关系人是当前企业的吗？':'Is the relationship person that needs to be added to the current enterprise?',
	'加载中。。。':'Loading...........',
	'操作失败，请联系管理员（田辉阳）':'The operation failed, please contact the administrator ( tianhy16 )',
	'选择企业':'Choose a business',
	'点击加载更多':'Click to load more',
	'暂存成功':'The temporary storage was successful',
	'申报提交成功':'The application was submitted successfully',
	
	// 举报投诉页面
	'历史记录':'History',
	'被举报人':'Reported Person',
	'被举报人单位':'Unit of Reported Person',
	'选择被举报人后自动带出':'Auto-filled after selecting the reported person',
	'举报内容':'Complaint Content',
	'请填写举报内容':'Please fill in the complaint content',
	'上传图片':'Upload Images',
	'上传文件':'Upload Files',
	'您的信息':'Your Information',
	'填写':'Fill in',
	'不填写':'Do not fill in',
	'单位':'Unit',
	'请填写您的单位':'Please fill in your unit',
	'手机':'Phone',
	'请填写您的手机':'Please fill in your phone number',
	'邮箱':'Email',
	'请填写您的邮箱':'Please fill in your email',
	'实名举报线索将优先进行调查，我们对举报人信息严格保密。不提供联系方式，我们将无法与您取得联系，了解更多信息，同时您也无法了解调查的进展与结果。':'Verified real-name reports will be prioritized for investigation. We strictly protect the identity of reporters. If you do not provide contact information, we will not be able to reach you for more details, and you will also be unable to track the progress and results of the investigation.',
	'举报投诉':'Complaint Report',
	'请选择被举报人':'Please select the reported person',
	'请填写您的姓名':'Please fill in your name',
	'请填写您的手机号或者邮箱，二选一':'Please fill in your phone number or email',
	'操作成功':'Operation successful',
	'操作失败':'Operation failed',
	'您已经提交过了':'You have already submitted',
}

export default labels